import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../../store/index';
import * as ContactStore from '../../store/patient/Contact';
import DashboardNavMenu from '../../components/layout/menu/DashboardNav'
import { seo } from '../../helper/Script';
import ContentLoader from 'react-content-loader';
import Moment from 'moment';
import * as AccountStore from '../../store/siteaccount/Account';
import * as SubscriptionStore from '../../store/patient/Subscription';
import * as LanguageResourcesStore from '../../store/LanguageResoures';
import { scrollTop, setTittle, transcationstatusColor } from '../../helper/formvalidation';
import Pagination from "react-js-pagination";
import { dateFormat, dateUTCFormat, dateFormatConvert, timeFormatConvert } from '../../helper/formvalidation';
import { getDiscountPrice } from './Booking';

// At runtime, Redux will merge together...
type DocumentListProps =
    ContactStore.ContactState & SubscriptionStore.SubscriptionState & AccountStore.AccountState & LanguageResourcesStore.LanguageResouresState// ... state we've requested from the Redux store
    & typeof ContactStore.actionCreators & typeof SubscriptionStore.actionCreators & typeof AccountStore.actionCreators & typeof LanguageResourcesStore.actionCreators// ... plus action creators we've requested
    & RouteComponentProps<{ startDateIndex: string }>; // ... plus incoming routing parameters
var patientLocalStroage: any = localStorage.getItem('Patient');
var pat = JSON.parse(patientLocalStroage);
var languagecontent: any = "";
var langdata: any = "";
var __currency: any = [];
class DynamicForms extends React.PureComponent<DocumentListProps> {
    constructor(props: any) {
        super(props);

    }
    state = {

        activePage: 1,
        activePagecount: 10,
        currentPagecount: 1,
        lists: []

    }

    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
        scrollTop();

    }
    componentDidUpdate() {
        seo(setTittle(languagecontent == "" ? "" : "Subscription"));

    }
    public render() {
        return (
            <React.Fragment>
                {this.renderSubscriptionList()}
            </React.Fragment>
        );
    }

    private ensureDataFetched() {
        this.props.getLangResources();
        this.props.getSubscriptionList();
        if (localStorage.getItem("LangResourcesValidations") != null)
            langdata = JSON.parse(localStorage.getItem("LangResourcesValidations") || "");



    }


    convertDate(time: any) {

        return Moment.utc(time).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('D MMM YYYY')
    }
    convertTime(time: any) {

        return Moment.utc(time).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('LT')
    }
    //handlePageChange(pageNumber: any) {
    //	var page = (pageNumber * 10) - 10;
    //	var pagenumber = page + 1;
    //	//console.log(page, pageNumber * 10)
    //	this.setState({ activePage: pageNumber, activePagecount: pageNumber * 10, currentPagecount: pagenumber });
    //	this.setState({ lists: this.props.paymentDetail.slice(page, pageNumber * 10) })
    //	//console.log(this.props.paymentDetail.slice(5, 10), "this.props.paymentDetail.slice(page, pageNumber * 5)")
    //}

    /*componentWillMount() {
        this.setState({ lists: this.props.paymentDetail.slice(0, 5) })
    }*/



    private renderSubscriptionList() {


        languagecontent = this.props.LanguageResoures;
        var _currency: any = "";
        __currency = this.props.Settings.filter((s: any) => s.name == "Currency");
        //var value: any;
        if (__currency.length == 0) {
            _currency = "";
        }
        else {
            if (__currency[0].value == "") {
                _currency = __currency[0].displayCode;
                localStorage.setItem("currency", _currency);
            }
            else {
                _currency = __currency[0].customizeValue;
                localStorage.setItem("currency", _currency);
            }


        }

        var currency: any = _currency;
        return (
            <React.Fragment>
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <DashboardNavMenu />
                            <div className="col-md-7 col-lg-8 col-xl-9">
                                <div id="pat_appointments" className="tab-pane fade show active">
                                    <div className="card card-table mb-0">
                                        <div className="card-body" style={{ padding: "10px" }}>
                                            {
                                                this.props.isLoading == true ? <ContentLoader title={langdata['loading'] == undefined ? "" : langdata['loading']} viewBox="0 0 400 100">
                                                    <rect x="0" y="20" rx="4" ry="4" width="400" height="15" />
                                                    <rect x="0" y="50" rx="4" ry="4" width="400" height="15" />
                                                    <rect x="0" y="80" rx="4" ry="4" width="400" height="15" />
                                                </ContentLoader> :
                                                    <React.Fragment>
                                                        <div className="table-responsive doc-module">
                                                            {
                                                                this.props.sublists.length == 0 ?
                                                                    <div className="p-4 center">{languagecontent['norecordsfound']}</div> :
                                                                    <div className="">
                                                                        <table className="table table-hover table-center mb-0 transactiontable">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Plan Name</th>
                                                                                    <th>Enrolled On</th>
                                                                                    <th>Validity Period</th>
                                                                                    <th>Frequency Value</th>
                                                                                    <th>Status</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {(this.state.lists.length > 0 ? this.state.lists : this.props.sublists.slice(0, 10)).map((transaction: SubscriptionStore.SubList) =>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <span style={{ height: '40px', fontSize: '25px', float: 'left', marginLeft:'-30px' }} className="nav-item dropdown has-arrow logged-item pr-0" >
                                                                                                <a href={"#collapseExample"} className="dropdown-toggle nav-link" data-toggle="collapse">

                                                                                                </a>
                                                                                            </span>
                                                                                            <span>{transaction.name}<br />({transaction.frequency})</span></td>
                                                                                        <td>{dateFormat(transaction.enrolledOn)}</td>
                                                                                        <td>{dateFormat(transaction.enrolledOn)}</td>
                                                                                        <td>{transaction.description}</td>
                                                                                        <td>Active</td>                                                                                        

                                                                                    </tr>

                                                                                )
                                                                                }</tbody>
                                                                            <tbody id={"collapseExample"} className=" collapse">

                                                                                <tr style={{ borderLeft: "7px solid rgb(194 184 184)" }}>
                                                                                    <th>Transaction Date</th>
                                                                                    <th>Amount</th>
                                                                                    <th>Date</th>
                                                                                    <th>Payment Status</th>
                                                                                </tr>

                                                                                {

                                                                                    this.props.sublists.map((child: SubscriptionStore.SubList) =>
                                                                                        <tr>
                                                                                            <td>{dateFormat(child.paidDate)}</td>
                                                                                            <td>{child.amount}</td>
                                                                                            <td>{dateFormat(child.paidDate)}</td>
                                                                                            <td>{child.paymentStatus}</td>
                                                                                        </tr>
                                                                                    )

                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                            }
                                                        </div>



                                                    </React.Fragment>

                                            }
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.flexiform, ...state.contact, ...state.subscriptionDetail, ...state.account, ...state.langResources }), // Selects which state properties are merged into the component's props
    ({ ...ContactStore.actionCreators, ...SubscriptionStore.actionCreators, ...AccountStore.actionCreators, ...LanguageResourcesStore.actionCreators })// Selects which action creators are merged into the component's props
)(DynamicForms as any);
